<template>
    <div id="consolenew_div" class="consolenew">
        <el-container>
            <el-header class="newHeader">
                <el-row>
                    <el-col :span="6">
                        <div class="consolenew_Logo">
                            媒体广告牌智控系统
                        </div>
                    </el-col>
                    <el-col :span="18">
                        <div class="Console" @click="ConsoleClick()">控制台</div>
                        <div class="head_date">{{nowTime}}</div>
                    </el-col>
                </el-row>
            </el-header>
            <el-main class="center">
                <el-row>
                    <el-col :span="24">
                        <el-row>
                            <el-col :span="16">
                                <my-map @changeSite="changeSite" @SetSiteData="initSiteData" @ShowSite="ShowSite" ref='map'/>
                            </el-col>
                            <el-col :span="8">
                                <my-ad :ADId="searchform.AdId" />
                                <my-site :SiteData="siteData" :IsShow="IsShowSite" @showMap="showMap" />
                                <my-report :SiteId="searchform.siteid" :IsShow="IsShowDetail" />
                                <my-device :SiteId="searchform.siteid" @changeAd="changeAd" :IsShow="IsShowDetail" />
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </el-main>
            <el-footer style="height: 39px" class="newfooter">
                <span>技术支持：上海兴驰电子有限公司</span>
            </el-footer>
        </el-container>
    </div>
</template>
<script>
import MyMap from './views/ConsolePlugin/Map.vue';
import MyAd from './views/ConsolePlugin/Ad.vue';
import MyDevice from './views/ConsolePlugin/Device.vue';
import MyReport from './views/ConsolePlugin/Report.vue';
import MySite from './views/ConsolePlugin/Site.vue';

export default {
    name: 'consolenew',
    data: function() {
        return {
            nowTime: '',
            searchform: {
                siteid: 1,
                AdId: 1,
            },
            siteData: [],
            IsShowSite: true,
            IsShowDetail: false,
        }
    },
    components: {
        MyMap,
        MyAd,
        MyDevice,
        MyReport,
        MySite
    },
    methods: {
        ConsoleClick() {
            this.$router.push({ path: '/console' });
        },
        timeFormate(timeStamp) {
            let year = new Date(timeStamp).getFullYear();
            let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
            let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
            let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
            let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
            let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
            this.nowTime = year + "." + month + "." + date + " " + hh + ":" + mm + ':' + ss + "  " + "星期" + '日一二三四五六'.charAt(new Date().getDay());
        },
        nowTimes() {
            this.timeFormate(new Date());
            setInterval(this.nowTimes, 1000);
            this.clear()
        },
        clear() {
            clearInterval(this.nowTimes)
            this.nowTimes = null;
        },
        initData() {},
        initParamsData() {},
        changeSite() {
            this.searchform.siteid = this.$store.state.SiteId;
        },
        initSiteData(data) {
            this.siteData = data;
        },
        ShowSite(val) {
            this.IsShowSite = val;
            this.IsShowDetail = !val;
        },
        showMap(row){
            this.$refs.map.showWindow(row);
        },
        changeAd() {
            this.searchform.AdId = this.$store.state.ADId;
        }
    },
    mounted() {
        this.nowTimes();
    },
    beforeDestroy() {
        this.clear();
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        next();
    },
    created() {
        this.initData();
        this.initParamsData();
    }
};
</script>
<style>
.consolenew .el-container {
    height: 100%;
}

.consolenew {
    background: url("assets/bg1080.png");
    background-size: 100% 100%;
    width: 100%;
    height: 100%;
    min-width: 1280px;
    min-height: 720px;
    overflow: hidden;
}

.consolenew_Logo {
    background: url("assets/logo_bg.png") no-repeat;
    background-size: 100% 100%;
    width: 425px;
    height: 55px;
    line-height: 55px;
    color: #FEFEFD;
    font-size: 1.60em;
    margin: 42px 0 0 12%;
    font-weight: bold;
    font-family: "Microsoft YaHei", "Times New Roman", sans-serif;
}

.el-main {
    overflow: inherit !important;
}

.center {
    width: 95%;
    height: 80%;
    margin-left: 3%;
    background: none;
}

.newHeader {
    height: 110px !important;
}

.head_date {
    position: absolute;
    right: 0;
    width: 20%;
    height: 50%;
    line-height: 3.7;
    color: #a4d0ff;
    font-size: 16px;
}

.Console {
    position: absolute;
    bottom: 8px;
    left: 55%;
    width: 120px;
    height: 35px;
    line-height: 35px;
    cursor: pointer;
    background-color: rgb(32, 80, 120, 0.6);
    color: #a4d0ff;
}

.newfooter {
    color: #74ccfe;
}

.newfooter span {
    margin-left: 1.9%;
}

.el-col {
    height: 100%;
    background: none;
}

.el-row {
    height: 100%;
    background: none;
}
</style>